<template>
  <el-row :gutter="15" class="wrapper">
    <el-col :md="6" v-if="isProductOperator">
      <div class="card section">
        <p class="page-title">待审核订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { state_in: ['pending'] } }">
              <p class="value">{{ data.orders_pending_count}}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6" v-if="isProductOperator">
      <div class="card section">
        <p class="page-title">待总管理员审核订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { state_in: ['wait_admin_audit'] } }">
              <p class="value">{{ data.orders_wait_admin_audit_count || 0 }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">待老板审核订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { state_in: ['wait_boss_audit'] } }">
              <p class="value">{{ data.orders_wait_boss_audit_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">待供应商BOSS确认订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { state_in: ['wait_supplier_boss_confirm'] } }">
              <p class="value">{{ data.orders_wait_supplier_boss_confirm_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">待供应商员工确认订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { state_in: ['wait_supplier_confirm'] } }">
              <p class="value">{{ data.orders_wait_supplier_confirm_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">送货中订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'delivering' } }">
              <p class="value">{{ data.order_delivery_delivering_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">待质检订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'reached' } }">
              <p class="value">{{ data.order_delivery_reached_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">待点数入库订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'checked' } }">
              <p class="value">{{ data.order_delivery_checked_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
    <el-col :md="6">
      <div class="card section">
        <p class="page-title">退厂返工订单数</p>
        <div class="content">
          <div class="item">
            <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'failed' } }">
              <p class="value">{{ data.order_delivery_failed_count }}</p>
            </bean-link>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash';

@Component
export default class MerchandiserHome extends Vue {
  data = {
    orders_pending_count: 0,
    orders_wait_boss_audit_count: 0,
    orders_wait_supplier_boss_confirm_count: 0,
    orders_wait_supplier_confirm_count: 0,
  };

  get isProductOperator() {
    return _.get(this.$root.user, 'user.product_operator');
  }

  async mounted() {
    this.data = await this.$request.get('/dashboard/merchandiser_role')
  }
}
</script>
